<div class="ads" [ngClass]="{'ads-70h' : isHomeAd }" *ngIf="(ads.length > 0 && isAdOn && !isHomeAd)">
  <!-- Boton para cerrar publicidad -->
  <div class="position-absolute mt-2 mr-2 ads-button animate__animated fadeIn" *ngIf="!isHomeAd && isMobile">
    <button class=" btn btn-icon-only rounded-circle" type="button" (click)="adsOff()"><span class=" btn-inner--icon"><i class="fas fa-times mb-2"></i></span></button>
  </div>
  <div class="ads-image animate__animated fadeIn" (click)="goLink(ads[0])" [ngClass]="{'ads-image': isMobile, 'ads-image-desktop' : !isMobile }">
    <img [src]="ads[0].url" alt="" class="ad-image">
  </div>
</div>
<div class="row" *ngIf="(ads.length > 0 && isHomeAd)">
  <div class="col">
    <div class="animate__animated fadeIn" (click)="goLink(ads[0])">
      <img [src]="ads[0].url" alt="" class="ads-responsive">
    </div>
  </div>
</div>